import styled, { css } from 'styled-components'
import { IMediaStylesProps } from './types'

export const getMediaStyles = ({
  $mediaItem: { width, height, rotation, coordinates, flip },
  $isVisible
}: IMediaStylesProps) => css`
  position: absolute;
  cursor: pointer;
  width: ${width}px;
  height: ${height}px;
  transform: rotate(${rotation}deg) scaleX(${flip?.x ? -1 : 1});
  left: ${coordinates.x}px;
  top: ${coordinates.y}px;
  visibility: ${$isVisible ? 'visible' : 'hidden'};
`

export const AiSkeletonItemWrapper = styled.div<{ $blurBackground?: boolean }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  ${({ $blurBackground }) =>
    $blurBackground
      ? css`
          filter: blur(12px);
        `
      : undefined}
`

export const MediaItemLoadingRoot = styled.div<IMediaStylesProps>`
  ${getMediaStyles};
  z-index: 2;
`

export const ScalableWrapper = styled.div<{
  $scale: number
  $canvasWidth: number
  $canvasHeight: number
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: ${({ $scale }) => `translate(-50%, -50%) scale(${$scale})`};
  transform-origin: center;
  background-color: black;
  width: ${({ $canvasWidth }) => $canvasWidth}px;
  height: ${({ $canvasHeight }) => $canvasHeight}px;
  z-index: 1;
  border-radius: ${({ $scale }) => `${8 / $scale}px`};
  overflow: hidden;

  /*make background transparent when skeleton has content */
  &:has(${AiSkeletonItemWrapper}:not(:empty)) {
    background-color: transparent;
  }
`

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`

export const CanvasLoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
`

export const CanvasWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
`

export const Image = styled.img<IMediaStylesProps>`
  ${getMediaStyles};
`

/** Sits inside `MediaItemLoadingRoot`; frame transform is applied on the root only. */
export const ImageInsideMediaFrame = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
`
